/*
 * Dhoop Chaon global scripts.
 * Moved out of inline <script> tags (layout/theme.liquid, sections/custom-announcement.liquid,
 * sections/cursor-crakers.liquid) so the code is cached once instead of shipped in every page's HTML.
 * Loaded with defer, so it runs after the HTML is parsed and before DOMContentLoaded.
 */

/* === Header icon colour (was inline at the end of layout/theme.liquid) === */
(function () {
  function applyIconColor() {
    const isMobile = window.innerWidth <= 768;
    const isHome = window.location.pathname === "/";

    let color = "#000"; // default black

    // Desktop + Homepage → White
    if (!isMobile && isHome) {
      color = "#fff";
    }

    // MOBILE always black
    if (isMobile) {
      color = "#000";
    }

    /* CART + WISHLIST + SEARCH (ALL ICONS) */
    document.querySelectorAll('#shopify-section-header a, #shopify-section-header button, #shopify-section-header .ecom-wishlist-model-btn, #shopify-section-header m-search-popup').forEach(el => {
      el.style.setProperty('color', color, 'important');

      el.querySelectorAll('svg, svg *').forEach(svg => {
        svg.style.setProperty('stroke', 'currentColor', 'important');
      });
    });
  }

  // Batch re-runs into one per frame (the cursor crackers add/remove nodes constantly)
  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyIconColor();
    });
  }

  // Run
  applyIconColor();

  // Re-run on dynamic changes
  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.body, { childList: true, subtree: true });

  // Resize support
  window.addEventListener('resize', scheduleApply);
})();

/* === Announcement slider (sections/custom-announcement.liquid) === */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.announcement-swiper')) return;
  if (typeof Swiper !== 'undefined') {
    new Swiper('.announcement-swiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      slidesPerView: 1,
      speed: 500,
      navigation: {
        nextEl: '.announcement-next',
        prevEl: '.announcement-prev'
      }
    });
  } else {
    console.warn('Swiper not found. Please ensure it is loaded in your theme.liquid or layout file.');
  }
});

/* === Cursor crackers (sections/cursor-crakers.liquid) === */
(function () {
  function num(value, fallback) {
    const n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function initCursorCrackers() {
    const section = document.getElementById('cursor-crackers-section');
    if (!section) return;
    const container = document.getElementById('cursor-crackers-container');
    const data = section.dataset;
    const settings = {
      enabled: data.enabled === 'true',
      maxParticles: num(data.maxParticles, 30),
      life: num(data.life, 900),
      sizeMin: num(data.sizeMin, 6),
      sizeMax: num(data.sizeMax, 18),
      colors: data.colors || '["#ffcf33","#ff6b6b","#8ce99a","#74c0fc","#f783ac"]',
      spawnOnMove: true,
      spawnOnClick: true,
      throttleMs: 20
    };

    try { settings.colors = JSON.parse(settings.colors); } catch(e) { settings.colors = null; }

    if (!settings.enabled) return;
    if (window.__cursorCrackersInitialized) return;
    window.__cursorCrackersInitialized = true;

    let particleCount = 0;
    const particles = new Set();
    let lastMove = 0;

    function rand(min, max) { return Math.random() * (max - min) + min; }
    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function spawn(x, y, options = {}) {
      if (particleCount >= settings.maxParticles) return;
      const el = document.createElement('div');
      el.className = 'cracker' + (Math.random() < 0.25 ? ' spark' : '');
      const size = Math.round(rand(settings.sizeMin, settings.sizeMax)) + 'px';
      el.style.setProperty('--cracker-size', size);
      el.style.setProperty('--cracker-life', (options.life || settings.life) + 'ms');
      const color = options.color || pick(settings.colors || ['#FFD700']);
      el.style.setProperty('--cracker-color', color);

      el.style.left = (x - (parseInt(size,10) / 2)) + 'px';
      el.style.top = (y - (parseInt(size,10) / 2)) + 'px';

      const angle = rand(0, Math.PI * 2);
      const distance = rand(30, 120);
      const dx = Math.round(Math.cos(angle) * distance) + 'px';
      const dy = Math.round(-Math.abs(Math.sin(angle) * distance)) + 'px';
      const rot = Math.round(rand(-720, 720)) + 'deg';

      el.style.setProperty('--dx', dx);
      el.style.setProperty('--dy', dy);
      el.style.setProperty('--rot', rot);

      container.appendChild(el);
      particleCount++;
      particles.add(el);

      const lifetime = options.life || settings.life;
      setTimeout(() => {
        if (el && el.parentNode) el.parentNode.removeChild(el);
        particleCount--;
        particles.delete(el);
      }, lifetime + 50);
    }

    function onMove(e) {
      const now = Date.now();
      if (now - lastMove < settings.throttleMs) return;
      lastMove = now;
      const x = e.clientX;
      const y = e.clientY;
      spawn(x + rand(-6,6), y + rand(-6,6));
      if (Math.random() < 0.15) spawn(x + rand(-10,10), y + rand(-10,10));
    }

    function onClick(e) {
      const x = e.clientX, y = e.clientY;
      for (let i=0;i<6;i++) {
        setTimeout(() => spawn(x + rand(-8,8), y + rand(-8,8)), i * 20);
      }
    }

    function onTouch(e) {
      const t = e.touches && e.touches[0];
      if (!t) return;
      spawn(t.clientX, t.clientY);
    }

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      if (settings.spawnOnMove) window.addEventListener('mousemove', onMove, { passive: true });
      if (settings.spawnOnClick) window.addEventListener('click', onClick, { passive: true });
      window.addEventListener('touchstart', onTouch, { passive: true });
    }

    window.cursorCrackers = {
      spawnAt: (x, y, opts) => spawn(x, y, opts),
      burstAt: (x, y, n = 8) => { for (let i=0;i<n;i++) spawn(x + rand(-12,12), y + rand(-12,12)); }
    };

    const observer = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('click', onClick);
        window.removeEventListener('touchstart', onTouch);
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Delay start by 5 seconds after DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initCursorCrackers, 5000);
  });
})();
